// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"4b10fc68874524f8","888":"242df7ff8dc576eb"}[chunkId] + ".css";
};